import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { ISendUserLoginOPTData } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the sent login otp mutation keys in react query cache.
 */
const MUT_SEND_USER_EMAIL_LOGIN_OTP = 'send-user-email-login-otp';

interface ISendUserLoginOTPOptions {
  onErrorCallback: (err: IApiError) => void;
  onSuccessCallback: (otpData: ISendUserLoginOPTData) => void;
}

/**
 * This performs an otp generation request on the server that is sent to the
 * user's mobile to get the OTP used during user login with email.
 */
export const useSendUserEmailLoginOTPMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: ISendUserLoginOTPOptions) => {
  const { mutate, data, isPending, error } = useMutation({
    mutationKey: [MUT_SEND_USER_EMAIL_LOGIN_OTP],
    networkMode: 'always',
    retry: false,
    mutationFn: USER_ACCOUNTS_API.sendUserEmailLoginOTP,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      onErrorCallback(err);
      errorLogToRemoteUtil({
        error,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'useSendUserLoginOTPMutation: Error',
        message: err.message,
      });

      return err;
    },
  });

  return {
    data,
    error,
    isPending,
    sendUserLoginOTP: mutate,
  };
};
